/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_Intelligence_To_ProvideInputs */

const en_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable intelligence to provide automated assists and document-based answers for this listing.`)
};

const es_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilita la inteligencia para proporcionar asistencia automatizada y respuestas basadas en documentos para este anuncio.`)
};

const fr_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activez l'intelligence pour fournir une assistance automatisée et des réponses basées sur des documents pour cette annonce.`)
};

const de_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviere die Intelligenz, um automatisierte Assistenz und dokumentenbasierte Antworten für dieses Inserat bereitzustellen.`)
};

const ja_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インテリジェンスを有効にして、この出品に関する自動アシストとドキュメントベースの回答を提供します。`)
};

const zh_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用智能系统以为此商品提供自动化协助和基于文档的解答。`)
};

const ar_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفعيل الذكاء الاصطناعي لتقديم مساعدة آلية وإجابات مستندة إلى الملفات لهذا الإعلان.`)
};

const id_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan kecerdasan untuk memberikan bantuan otomatis dan jawaban berbasis dokumen untuk listing ini.`)
};

const it_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita l'intelligenza per fornire assistenza automatizzata e risposte basate sui documenti per questo annuncio.`)
};

const ru_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включите искусственный интеллект для предоставления автоматических консультаций и ответов на основе документов для этого объявления.`)
};

const pt_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilite a inteligência para fornecer assistência automatizada e respostas baseadas em documentos para este anúncio.`)
};

const ko_enable_intelligence_to_provide = /** @type {(inputs: Enable_Intelligence_To_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인텔리전스를 활성화하여 이 상품에 대한 자동 지원 및 문서 기반 답변을 제공하세요.`)
};

/**
* | output |
* | --- |
* | "Enable intelligence to provide automated assists and document-based answers for this listing." |
*
* @param {Enable_Intelligence_To_ProvideInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enable_intelligence_to_provide = /** @type {((inputs?: Enable_Intelligence_To_ProvideInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_Intelligence_To_ProvideInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enable_intelligence_to_provide(inputs)
	if (locale === "es") return es_enable_intelligence_to_provide(inputs)
	if (locale === "fr") return fr_enable_intelligence_to_provide(inputs)
	if (locale === "de") return de_enable_intelligence_to_provide(inputs)
	if (locale === "ja") return ja_enable_intelligence_to_provide(inputs)
	if (locale === "zh") return zh_enable_intelligence_to_provide(inputs)
	if (locale === "ar") return ar_enable_intelligence_to_provide(inputs)
	if (locale === "id") return id_enable_intelligence_to_provide(inputs)
	if (locale === "it") return it_enable_intelligence_to_provide(inputs)
	if (locale === "ru") return ru_enable_intelligence_to_provide(inputs)
	if (locale === "pt") return pt_enable_intelligence_to_provide(inputs)
	return ko_enable_intelligence_to_provide(inputs)
});